import React, { useMemo } from 'react'
import { Badge, Benefit, CardBody, CardHeader } from './styles'
import { Item } from './styles'
import { Benefits } from './styles'
import { Title } from './styles'

import { Container } from './styles'

function CardPlan({ item, blur, data }) {
	const { benefits, title, nmeroDeMensalidadesGrtis, price } = item.fields
	console.log("BLUR", blur)
	const months = useMemo(() => {
		if (!data && nmeroDeMensalidadesGrtis) return 0
		return data.numeroMesesBonificacao || nmeroDeMensalidadesGrtis
	}, [data, nmeroDeMensalidadesGrtis])

	const standardText = [
		<p className="subtitle">{months} mensalidades grátis</p>,
		<p>Após esse período, a partir de</p>,
		<p className="subtitle">{price || 'R$ 18,90'}/mês</p>
	]

	return (
		<Container>
			<CardHeader blur={blur}>
				<Badge>
					<p>ADQUIRA GRÁTIS</p>
				</Badge>
				<Title>{title}</Title>
				{months === 0 || months === 999 ? (
					<p className="subtitle">Sem mensalidades</p>
				) : (
					standardText
				)}
			</CardHeader>
			<CardBody blur={blur}>
				<Benefits>
					{benefits.map((benefit, index) => (
						<Item
							key={benefit.text}
							style={{
								backgroundColor: index % 2 === 0 ? '#F7F7FC' : '#ffffff',
								marginTop: index === 0 ? '10px' : '0',
								padding: '16px 32px 16px 0'
							}}
						>
							<img
								src="/clientedux/assets/check.svg"
								alt="check"
								style={{
									filter: blur ? 'blur(3px)' : 'none'
								}}
							/>
							<Benefit bold={benefit.isBold} blur={blur}>
								<p>{benefit.text}</p>
							</Benefit>
							{/* {index !== benefits.length - 1 && <hr />} */}
						</Item>
					))}
				</Benefits>
			</CardBody>
		</Container>
	)
}

export default CardPlan
